import { useConversationsStore } from '@/stores/conversations/conversations.store';
import { AssignmentValueType } from '@/types/conversation.types';

export default function updateConversationsAllCount(data: AssignmentValueType): void {
  useConversationsStore().handelCounterUpdate(data);
}
